import ForwardingOptionState from '../store/schema/ForwardingOptionState';
import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';

export interface DiscardForwardingOptionState {
    optionState: ForwardingOptionState;
}

export default action('discardForwardingOption')(function discardForwardingOption() {
    store.choiceGroupSelection = null;
    store.forwardingEmailAddress = null;
    store.keepCopy = null;
});
